import { atom } from 'recoil'

import { ProfileSection } from '../../types/profile'

export const profileFirstNameAtom = atom<string | undefined>({
  key: 'profileFirstNameAtom',
  default: undefined,
})

export const profileLastNameAtom = atom<string | undefined>({
  key: 'profileLastNameAtom',
  default: undefined,
})

export const profileEmailAtom = atom<string | undefined>({
  key: 'profileEmailAtom',
  default: undefined,
})

export const profileMobileAtom = atom<string | undefined>({
  key: 'profileMobileAtom',
  default: undefined,
})

export const profileSectionInEditAtom = atom<ProfileSection | null>({
  key: 'profileSectionInEditAtom',
  default: null,
})
